import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { PromotionResponse } from '@medindex-webapi';

// amount promotion per page
const PROMOTION_PER_PAGE = 6;

interface PromotionWithActive extends PromotionResponse {
  active?: boolean;
}
@Component({
  selector: 'app-all-promotions',
  templateUrl: './all-promotions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllPromotionsComponent implements OnChanges {
  @Input()
  promotionsList: PromotionWithActive[] | undefined = [];
  promotionsOnPage = PROMOTION_PER_PAGE;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.promotionsList) {
      this.promotionsList = this.promotionsList?.map(
        (promotion: PromotionWithActive, index: number) => ({
          ...promotion,
          active: index < this.promotionsOnPage,
        })
      );
    }
  }

  showMore(): void {
    if (
      this.promotionsList?.length &&
      this.promotionsOnPage < this.promotionsList?.length
    ) {
      this.promotionsOnPage += PROMOTION_PER_PAGE;
      this.promotionsList = this.promotionsList?.map(
        (promotion: PromotionWithActive, index: number) => ({
          ...promotion,
          active: index < this.promotionsOnPage,
        })
      );
    }
  }
}
